import {
    Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef,
    TemplateRef, SimpleChanges
} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ICountry, IState, IGetPermissionMandatoryField } from '../interface';
import { GeneralService } from 'src/app/services/general.service';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { ITimeZoneModel, IKeypadZoneModel, IResponseModel } from '../models/ProspectModel';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { FacilityService } from 'src/app/services/facility.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { CommonMethodService } from 'src/app/Shared/common-method.service';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
    selector: 'app-alternate-contact',
    templateUrl: './alternate-contact.component.html',
    styleUrls: ['./alternate-contact.component.scss'],
    standalone: false
})

export class AlternateContactComponent implements OnInit {
    @Output() emitAltContactForm: EventEmitter<any> = new EventEmitter<any>();
    @Input() altContactCallScriptFields = [];
    @Input() section;
    @Input() LeaseNo;
    @Input() tenantCountryId;
    @Input() FacilityId;
    @Input() tenantId;
    @Input() ContactList;
    @Input() noOfContacts;
    @Input() FacilitygateSystemResponse: IResponseModel;
    @Output() alternateContactInfo: EventEmitter<any> = new EventEmitter<any>();
    @Output() dirtyFlag: EventEmitter<any> = new EventEmitter<any>();
    @Output() existingAltContactDirtyFlag:EventEmitter<any> = new EventEmitter<any>();
    @Input() IsAlternateContactMandatory;
    @Input() IsSendLateLienNotices;
    @Input() unitGateCode;
    @Input() existingAlternateContactstemp;
    @Input() isExemptAltContactMandatory;
    @Input() facilityGateSystemDetails;
    @Input() readonlyMode;
    @Input() isCreateRental;
    @Input() existingAltContacts :any[]=[];
    @ViewChild('alternateContactPopup', { static: true }) alternateContactPopup: ModalDirective;
    @ViewChild('primaryValidationTemplate', { static: true }) primaryValidationTemplate: TemplateRef<any>;
    modalConfig = {
  backdrop: 'static'
};
    primaryValidationTemplateModalRef: BsModalRef;
    ACData;
    alternateContactForm: FormGroup;
    countryList: ICountry[];
    countrySelectedAC: number;
    stateListAC: IState[];
    alternateContactsGridData = [];
    alternateDetails;
    gateAccessChecked;
    autoGeneratedGateCode : string = '';
    facilityGateDetails;
    isEdit = false;
    itemIndex;
    formDetails;
    tempId = 0;
    sendLettersChecked = false;
    emergencyContactChecked = false;
    timeZoneList: ITimeZoneModel[];
    keypadZoneList: IKeypadZoneModel[];
    gateSystemResponse: IResponseModel;
    isGateCodeExist: number = 0; // 0 - false, 1 - true and 2 - api called
    modalRef: BsModalRef;
    public PhoneNumberMask: String = '(000)000-0000';
    public phoneNumberExtnMask: String = '(000)000-0000 x 000';
    emailIdsPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
    alternateContactReqList = [];
    LocationFields;
    gateSetting;
    requireUniqueAccessCode = false;
    backUpAlternateContactData = [];
    codeChangeSubject: Subject<any> = new Subject();
    gateAccessMaxLength = 15;
    gateAccessMinLength = 0;
    emptyStateList = false;
    gateAccessCheckedManually:boolean = false
    public loaderIcon: Promise<boolean>;

    public onStartfocus(args): void {
        args.selectionStart = 1;
        args.selectionEnd = 1;
    }

    constructor(private formBuilder: FormBuilder,
        private generalService: GeneralService,
        private facOpsDataService: FacOpsDataService,
        private modalService: BsModalService,
        private prospectService: ProspectService,
        private facilityServices: FacilityService,
        private commonMethodService: CommonMethodService,
        private modalWrapper: ModalWrapperService) { }

    ngOnInit() {
        this.alternateContactForm = this.formBuilder.group({
            ACId: [''],
            ACFirstName: ['', [Validators.required, this.noWhitespaceValidator]],
            ACMiddleName: [''],
            ACLastName: ['', [Validators.required, this.noWhitespaceValidator]],
            ACAddress: [''],
            ACCity: [''],
            ACState: [''],
            ACZipCode: [''],
            ACCountry: ['', Validators.required],
            ACCellPhone: ['', this.cellPhoneValidator],
            ACCellDialInCode: [''],
            ACHomePhone: ['', this.cellPhoneValidator],
            ACHomeDialInCode: [''],
            ACWorkPhone: ['', this.cellPhoneValidator],
            ACWorkDialInCode: [''],
            ACEmail: ['', [Validators.required, Validators.pattern(this.emailIdsPattern)]],
            ACFax: ['', this.cellPhoneValidator],
            ACFaxDialInCode: [''],
            SendLetters: [false],
            IsEmergencyContact: [false],
            GateAccess: [false],
            ACGateCode: [''],
            ACTimeZone: [''],
            ACKeypadZone: [''],
            CheckAlternateContact: [''],
            IsPrimaryAlternateContact: [''],
        });

        this.getCountries();
        this.alternateContactForm.get('ACGateCode').disable();
        this.alternateContactForm.get('ACTimeZone').disable();
        this.alternateContactForm.get('ACKeypadZone').disable();
        this.checkGateSystemIntegrated(this.FacilityId);
        this.getACCountry(this.tenantCountryId);
        this.alternateContactForm.patchValue({ ACCountry: this.tenantCountryId });
        this.setMandatoryField();
        if (this.getAlternateContactService) {
            this.alternateContactsGridData = this.getAlternateContactService.length == 0 ? this.ContactList : this.getAlternateContactService;
            this.alternateContactsGridData.map((item) => {
                if (!item.AlternateId) {
                    item.AlternateId = -1 * Math.random();
                }
            })
        }
        this.codeChangeSubject.pipe(debounceTime(400),distinctUntilChanged()).subscribe(event => {
            this.onBlurGateCode(event.target.value);
        });
        this.facOpsDataService.emitAltContactCallScriptClose.subscribe((event) => {
            if (event && event.trigger) {
                if (this.disableSave()) {
                    this.onCancelAC();
                } else {
                    this.onACSave();
                }
            }
        });
        this.facOpsDataService.emitAltContactCallScriptOpen.subscribe((event) => {
            if (event) {
                this.onAddClicked();
            }
        });
    }

  ngOnChanges(changes: SimpleChanges) {
        let contact;
        if (changes['noOfContacts'] !== undefined) {
            contact = changes['noOfContacts'].currentValue;
            if (contact !== 0) {
                this.alternateContactsGridData = this.ContactList;
                this.backUpAlternateContactData = this.ContactList
                this.alternateContactsGridData.map((item) => {
                    if (!item.AlternateId) {
                        item.AlternateId = -1 * Math.random();
                    }
                })
              this.validateCarriedOverContacts();
            }
      }

      if (changes['FacilitygateSystemResponse']?.currentValue) {
        this.checkGateSystemIntegrated(this.FacilityId);
      }
    }

    getCountries() {
        this.generalService.getCountries().subscribe((response: ICountry[]) => {
            this.countryList = response;
        });
    }

    onACCountryChange(obj) {
        if (obj == 1 || obj == 2) {
            this.emptyStateList = false;
            if (!this.formDetails || (this.formDetails && this.formDetails.CountryId && this.formDetails.CountryId !== obj)) {
                this.alternateContactForm.patchValue({ ACState: '' });
            }
            this.alternateContactForm.get('ACState').enable();
            this.getStatesForAC(obj);
            this.getACCountry(obj, true);
        } else {
            this.emptyStateList = true;
            this.stateListAC = [];
            this.alternateContactForm.patchValue({ ACState: '0' });
            this.alternateContactForm.get('ACState').disable();
        }
        if (!this.alternateContactForm.get('ACCellDialInCode').dirty) {
            this.alternateContactForm.patchValue({ ACCellDialInCode: obj });
        }
        if (!this.alternateContactForm.get('ACHomeDialInCode').dirty) {
            this.alternateContactForm.patchValue({ ACHomeDialInCode: obj });
        }
        if (!this.alternateContactForm.get('ACWorkDialInCode').dirty) {
            this.alternateContactForm.patchValue({ ACWorkDialInCode: obj });
        }
        if (!this.alternateContactForm.get('ACFaxDialInCode').dirty) {
            this.alternateContactForm.patchValue({ ACFaxDialInCode: obj });
        }
    }

    getStatesForAC(id) {
        this.generalService.getStates(id).subscribe((response: IState[]) => {
            this.stateListAC = response;
        });
    }

    getACCountry(id, isCountryChange?) {
        this.generalService.getCountry(id).subscribe((response: ICountry) => {
            this.countrySelectedAC = response.Id;
            if (this.formDetails && (this.formDetails.CountryId && this.formDetails.CountryId == id)) {
                this.alternateContactForm.patchValue({
                    ACState: this.countrySelectedAC == 1 || this.countrySelectedAC == 2 ? this.alternateContactForm.value.ACState : '0'
                });
            } else {
                this.alternateContactForm.patchValue({
                    ACCountry: this.countrySelectedAC,
                    ACState: this.countrySelectedAC == 1 || this.countrySelectedAC == 2 ? '' : '0'
                });
            }
            if (!this.alternateContactForm.get('ACCellDialInCode').dirty) {
                this.alternateContactForm.patchValue({ ACCellDialInCode: response.Id });
            } else { }
            if (!this.alternateContactForm.get('ACHomeDialInCode').dirty) {
                this.alternateContactForm.patchValue({ ACHomeDialInCode: response.Id });
            } else { }
            if (!this.alternateContactForm.get('ACWorkDialInCode').dirty) {
                this.alternateContactForm.patchValue({ ACWorkDialInCode: response.Id });
            } else { }
            if (!this.alternateContactForm.get('ACFaxDialInCode').dirty) {
                this.alternateContactForm.patchValue({ ACFaxDialInCode: response.Id });
            } else { }
            if (!isCountryChange) {
                this.alternateContactForm.markAsUntouched();
                this.alternateContactForm.markAsPristine();
                this.alternateContactForm.setErrors(null);
            }
        });
    }

 onAddClicked() {
        this.isEdit = false;
        this.isGateCodeExist = 0;
        this.alternateContactForm.reset();
        this.sendLettersChecked = false;
        this.emergencyContactChecked = false;
         if (!this.gateAccessChecked) {
             this.alternateContactForm.get('GateAccess').setValue(false);
             this.alternateContactForm.get('GateAccess').disable();
             this.alternateContactForm.get('ACGateCode').disable();
             this.alternateContactForm.get('ACTimeZone').disable();
             this.alternateContactForm.get('ACKeypadZone').disable();
             this.alternateContactForm.get('ACGateCode').setValidators(Validators.nullValidator);
             this.alternateContactForm.get('ACTimeZone').setValidators(Validators.nullValidator);
             this.alternateContactForm.get('ACKeypadZone').setValidators(Validators.nullValidator);
         } else {
            this.alternateContactForm.get('GateAccess').enable();
            this.alternateContactForm.get('GateAccess').setValue(false);
            this.alternateContactForm.get('ACGateCode').disable();
            this.alternateContactForm.get('ACTimeZone').disable();
            this.alternateContactForm.get('ACKeypadZone').disable();
            this.alternateContactForm.get('ACGateCode').setValidators(Validators.nullValidator);
            this.alternateContactForm.get('ACTimeZone').setValidators(Validators.nullValidator);
            this.alternateContactForm.get('ACKeypadZone').setValidators(Validators.nullValidator);
         }
        this.alternateContactForm.patchValue({ 
            ACTimeZone: '',
            ACKeypadZone: ''
        });         
        this.alternateContactForm.markAsPristine();
        this.alternateContactForm.markAsUntouched();
        this.getACCountry(environment.defaultCountryId);
        this.alternateContactForm.patchValue({ ACCountry: environment.defaultCountryId });
        this.onACCountryChange(environment.defaultCountryId);
        this.modalWrapper.openDirective(this.alternateContactPopup);
        this.emitAltContactForm.emit(true);
        this.alternateContactForm.markAsPristine();
        this.alternateContactForm.markAsUntouched();
        this.alternateContactForm.setErrors(null);
        this.alternateContactForm.get('CheckAlternateContact').setValue('true');
        this.alternateContactForm.get('IsPrimaryAlternateContact').setValue(false);

        if (this.IsSendLateLienNotices) {
            this.alternateContactForm.get('SendLetters').setValue(true)
            this.alternateContactForm.get('SendLetters').disable();
            this.alternateContactForm.get('ACAddress').setValidators([Validators.required, this.noWhitespaceValidator]);
            this.alternateContactForm.get('ACCity').setValidators([Validators.required, this.noWhitespaceValidator]);
            this.alternateContactForm.get('ACZipCode').setValidators([Validators.required, this.noWhitespaceValidator]);
            this.alternateContactForm.get('ACState').setValidators(Validators.required);
            this.alternateContactForm.get('ACAddress').updateValueAndValidity();
            this.alternateContactForm.get('ACCity').updateValueAndValidity();
            this.alternateContactForm.get('ACZipCode').updateValueAndValidity();
            this.alternateContactForm.get('ACState').updateValueAndValidity();
        } else {
            this.checkValidityOfLocationFields();
        }
        this.alternateContactForm.get('IsPrimaryAlternateContact').setValue(false)
        this.alternateContactForm.get('IsPrimaryAlternateContact').disable();

        if (this.alternateContactsGridData == null) {
            this.alternateContactForm.get('IsPrimaryAlternateContact').setValue(true)
            this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
        } else {
            let existingAlternateContacts = this.alternateContactsGridData.filter(alt => !alt.Deleted && alt.CheckAlternateContact);
            if (existingAlternateContacts.length >= 1) {
                this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
            }
        }
    }

    deleteModal(template: TemplateRef<any>) {
        this.openModal(template);
    }

    deleteAlternateContact() {
        let alternateObj = this.alternateContactsGridData.find(o => o.AlternateId === this.formDetails.AlternateId);
        if (alternateObj) {
            alternateObj.Deleted = true;
        }

        this.alternateContactsGridData.map(ac => {
            if (ac.AlternateId === this.formDetails.AlternateId) {
                ac.Deleted = true
            }
        })

        let existingAlternateContacts = this.alternateContactsGridData.filter(alt => !alt.Deleted && alt.CheckAlternateContact);
        this.existingAlternateContactstemp = this.alternateContactsGridData.filter(alt => !alt.Deleted && alt.CheckAlternateContact);

        if (existingAlternateContacts.length == 1) {
            existingAlternateContacts[0].IsPrimaryAlternateContact = true;
        }

        this.alternateContactPopup.hide();
        this.emitAltContactForm.emit(false);
        this.alternateContactInfo.emit(this.alternateContactsGridData);
        this.modalRef.hide();
        this.dirtyFlag.emit(true);
    }

    checkAlternateContactLIst() {
        if (this.alternateContactsGridData) {
            let count = this.alternateContactsGridData.filter((ele) => (ele.Deleted !== true));
            if (count && count.length && count.length > 0) {
                const alternatecontact = count.findIndex(ac => ac.CheckAlternateContact);
                if (alternatecontact == -1) {
                    return 1;
                } else {
                    return 2;
                }
                return 1;
            }
            return 0;
        }
        return 0;
    }

    onACSave() {
        this.alternateContactsGridData = this.alternateContactsGridData || [];
        let existingAlternateContacts = this.alternateContactsGridData.filter(alt => !alt.Deleted && alt.CheckAlternateContact);
        if (this.isEdit === false) {
            this.tempId = -1 * Math.random();
            this.ACData = {
                AlternateId: this.tempId,
                FirstName: this.alternateContactForm.value.ACFirstName,
                MiddleName: this.alternateContactForm.value.ACMiddleName === null ? '' : this.alternateContactForm.value.ACMiddleName,
                LastName: this.alternateContactForm.value.ACLastName,
                Address: this.alternateContactForm.value.ACAddress === null ? '' : this.alternateContactForm.value.ACAddress,
                City: this.alternateContactForm.value.ACCity === null ? '' : this.alternateContactForm.value.ACCity,
                State: (Number(this.alternateContactForm.value.ACCountry) !== 1 && Number(this.alternateContactForm.value.ACCountry) !== 2) ? null :
                    Number(!this.alternateContactForm.value.ACState) ? null : { Id: this.alternateContactForm.value.ACState, Name: '', Code: '' },
                Zip: this.alternateContactForm.value.ACZipCode === null ? '' : this.alternateContactForm.value.ACZipCode,
                CountryId: this.alternateContactForm.value.ACCountry,
                CellPhoneNumber: this.alternateContactForm.value.ACCellPhone === null ? '' : this.alternateContactForm.value.ACCellPhone,
                CellPhoneCountryId: this.alternateContactForm.value.ACCellDialInCode,
                HomePhone: this.alternateContactForm.value.ACHomePhone === null ? '' : this.alternateContactForm.value.ACHomePhone,
                HomePhoneCountryId: this.alternateContactForm.value.ACHomeDialInCode,
                WorkPhone: this.alternateContactForm.value.ACWorkPhone === null ? '' : this.alternateContactForm.value.ACWorkPhone,
                WorkPhoneCountryId: this.alternateContactForm.value.ACWorkDialInCode,
                Email: this.alternateContactForm.value.ACEmail === null ? '' : this.alternateContactForm.value.ACEmail,
                Fax: this.alternateContactForm.value.ACFax === null ? '' : this.alternateContactForm.value.ACFax,
                FaxCountryId: this.alternateContactForm.value.ACFaxDialInCode,
                SendLetters: this.alternateContactForm.controls['SendLetters'].value,
                IsEmergencyContact: this.alternateContactForm.controls['IsEmergencyContact'].value,
                GateAccess: this.alternateContactForm.controls['GateAccess'].value,
                AccessCode: this.alternateContactForm.value.ACGateCode === null ? '' : this.alternateContactForm.value.ACGateCode,
                TimeZone: this.alternateContactForm.value.ACTimeZone,
                KeypadZone: this.alternateContactForm.value.ACKeypadZone,
                isEdit: true,
                Deleted: false,
                CheckAlternateContact: this.alternateContactForm.value.CheckAlternateContact == 'true',
                IsPrimaryAlternateContact: this.alternateContactForm.value.CheckAlternateContact == 'true' ? (!existingAlternateContacts.length ? true : this.alternateContactForm.controls['IsPrimaryAlternateContact'].value) : false
            };
            this.alternateContactsGridData.push(this.ACData);
        } else {
            this.ACData = {
                AlternateId: this.alternateContactForm.value.ACId,
                FirstName: this.alternateContactForm.value.ACFirstName,
                MiddleName: this.alternateContactForm.value.ACMiddleName === null ? '' : this.alternateContactForm.value.ACMiddleName,
                LastName: this.alternateContactForm.value.ACLastName,
                Address: this.alternateContactForm.value.ACAddress === null ? '' : this.alternateContactForm.value.ACAddress,
                City: this.alternateContactForm.value.ACCity === null ? '' : this.alternateContactForm.value.ACCity,
                State: (Number(this.alternateContactForm.value.ACCountry) !== 1 && Number(this.alternateContactForm.value.ACCountry) !== 2) ? null :
                    Number(!this.alternateContactForm.value.ACState) ? null : { Id: this.alternateContactForm.value.ACState, Name: '', Code: '' },
                Zip: this.alternateContactForm.value.ACZipCode === null ? '' : this.alternateContactForm.value.ACZipCode,
                CountryId: this.alternateContactForm.value.ACCountry,
                CellPhoneNumber: this.alternateContactForm.value.ACCellPhone === null ? '' : this.alternateContactForm.value.ACCellPhone,
                CellPhoneCountryId: this.alternateContactForm.value.ACCellDialInCode,
                HomePhone: this.alternateContactForm.value.ACHomePhone === null ? '' : this.alternateContactForm.value.ACHomePhone,
                HomePhoneCountryId: this.alternateContactForm.value.ACHomeDialInCode,
                WorkPhone: this.alternateContactForm.value.ACWorkPhone === null ? '' : this.alternateContactForm.value.ACWorkPhone,
                WorkPhoneCountryId: this.alternateContactForm.value.ACWorkDialInCode,
                Email: this.alternateContactForm.value.ACEmail === null ? '' : this.alternateContactForm.value.ACEmail,
                Fax: this.alternateContactForm.value.ACFax === null ? '' : this.alternateContactForm.value.ACFax,
                FaxCountryId: this.alternateContactForm.value.ACFaxDialInCode,
                SendLetters: this.alternateContactForm.controls['SendLetters'].value,
                IsEmergencyContact: this.alternateContactForm.controls['IsEmergencyContact'].value,
                GateAccess: this.alternateContactForm.controls['GateAccess'].value,
                AccessCode: this.alternateContactForm.value.ACGateCode === null ? '' : this.alternateContactForm.value.ACGateCode,
                TimeZone: this.alternateContactForm.value.ACTimeZone,
                KeypadZone: this.alternateContactForm.value.ACKeypadZone,
                isEdit: true,
                CheckAlternateContact: this.alternateContactForm.value.CheckAlternateContact == 'true',
                IsPrimaryAlternateContact: this.alternateContactForm.value.CheckAlternateContact == 'true' ? (existingAlternateContacts.length == 1 ? true : this.alternateContactForm.controls['IsPrimaryAlternateContact'].value) : false,
                Deleted: false
            };
            if (this.alternateContactsGridData) {
                let index = this.alternateContactsGridData.findIndex(o => o.AlternateId === this.alternateContactForm.value.ACId);
                if (index !== -1) {
                    this.alternateContactsGridData[index] = this.ACData;
                    this.existingAltContactDirtyFlag.emit(this.invalidCarriedOverContacts());
                }
            }
        }
        this.alternateContactPopup.hide();
        this.emitAltContactForm.emit(false);
        this.dirtyFlag.emit(true);
        this.alternateContactInfo.emit(this.alternateContactsGridData);
        this.setAlternateContactService = this.alternateContactsGridData;
    }

    checkDirty(ev, alterId) {
        let alterObj = this.alternateContactsGridData.find(o => o.AlternateId === alterId);
        if (alterObj) {
            alterObj.isEdit = true;
        }
        this.dirtyFlag.emit(true); // send it to rental
    }

    onClickSendLetters(eve) {
        this.sendLettersChecked = eve.target.checked;
        if (eve.target.checked) {
            this.sendLettersChecked = true;
            let existingAlternateContacts = this.alternateContactsGridData.filter(alt => !alt.Deleted && alt.CheckAlternateContact);
            if (this.alternateContactForm.get('IsPrimaryAlternateContact').status == "DISABLED" && this.alternateContactForm.get('IsPrimaryAlternateContact').value && existingAlternateContacts.length == 1) {
                this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
            } else {
                this.alternateContactForm.get('IsPrimaryAlternateContact').enable();
            }
        } else {
            this.sendLettersChecked = false;
            this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
            let existingAlternateContacts = this.alternateContactsGridData.filter(alt => !alt.Deleted && alt.CheckAlternateContact);
            if (existingAlternateContacts.length > 1) {
                this.alternateContactForm.get('IsPrimaryAlternateContact').setValue(false);
            }
        }
        this.checkValidityOfLocationFields();
        this.alternateContactForm.get('ACAddress').updateValueAndValidity();
        this.alternateContactForm.get('ACCity').updateValueAndValidity();
        this.alternateContactForm.get('ACZipCode').updateValueAndValidity();
        this.alternateContactForm.get('ACState').updateValueAndValidity();
    }

     onClickEmergencyContact(eve) {
        this.emergencyContactChecked = eve.target.checked;
        if (eve.target.checked){
             this.emergencyContactChecked = true;
        this.alternateContactForm.get('IsEmergencyContact').setValue(true);
        } else {
            this.emergencyContactChecked = false;
        this.alternateContactForm.get('IsEmergencyContact').setValue(false);
          
        }
    }

    async enableGateFields(checked, option, AlternateId) {
        try {
            this.loaderIcon = Promise.resolve(true);
            if (checked) {
                this.gateAccessCheckedManually = true;
                this.alternateContactForm.get('ACGateCode').enable();
                this.alternateContactForm.get('ACTimeZone').enable();
                this.alternateContactForm.get('ACKeypadZone').enable();
                if (this.timeZoneList?.length) {
                    this.timeZoneList.forEach((item) => {
                        if (item.Default === true) { this.alternateContactForm.patchValue({ ACTimeZone: item.TimeZoneId }); }
                    })
                };
                if (this.keypadZoneList?.length) {
                    this.keypadZoneList.forEach((item) => {
                        if (item.Default === true) { this.alternateContactForm.patchValue({ ACKeypadZone: item.KeypadZoneId }); }
                    })
                };
                if (this.gateAccessChecked || checked) {
                    this.alternateContactForm.get('ACGateCode').setValidators([Validators.required, this.noWhitespaceValidator, Validators.minLength(this.gateAccessMinLength), Validators.maxLength(this.gateAccessMaxLength)]);
                    if (this.alternateContactForm.get('ACGateCode') && !this.alternateContactForm.get('ACGateCode').value && this.facilityGateSystemDetails?.AutoGenerateAccessCode) {
                        await this.autoPopulateGateCode(this.FacilityId);
                        this.alternateContactForm.get('ACGateCode').setValue(this.autoGeneratedGateCode);
                    }
                } else {
                    this.alternateContactForm.get('ACGateCode').setValidators(null);
                }
                this.alternateContactForm.get('ACTimeZone').setValidators(Validators.required);
                this.alternateContactForm.get('ACKeypadZone').setValidators(Validators.required);
                if (option == 1) {
                    this.alternateContactForm.patchValue({ GateAccess: true });
                }
                this.loaderIcon = Promise.resolve(false);
            } else {
                this.gateAccessCheckedManually = false;
                this.isGateCodeExist = 0;
                this.alternateContactForm.get('ACGateCode').disable();
                this.alternateContactForm.get('ACTimeZone').disable();
                this.alternateContactForm.get('ACKeypadZone').disable();
                this.alternateContactForm.patchValue({
                    ACGateCode: '',
                    ACTimeZone: '',
                    ACKeypadZone: ''
                });
                this.alternateContactForm.get('ACGateCode').setValidators(null);
                this.alternateContactForm.get('ACTimeZone').setValidators(null);
                this.alternateContactForm.get('ACKeypadZone').setValidators(null);
                if (option == 1) {
                    this.alternateContactForm.patchValue({ GateAccess: false });
                    if (this.alternateContactsGridData) {
                        let index = this.alternateContactsGridData.findIndex(o => o.AlternateId === AlternateId);
                        if (index !== -1) {
                            this.alternateContactsGridData[index].AccessCode = this.alternateContactForm.value.ACGateCode === null ? '' : this.alternateContactForm.value.ACGateCode;
                            this.alternateContactsGridData[index].TimeZone = this.alternateContactForm.value.ACTimeZone === null ? '' : this.alternateContactForm.value.ACTimeZone;
                            this.alternateContactsGridData[index].KeypadZone = this.alternateContactForm.value.ACKeypadZone === null ? '' : this.alternateContactForm.value.ACKeypadZone;
                        }
                    }
                }
            }
            this.alternateContactForm.get('ACGateCode').updateValueAndValidity();
            this.alternateContactForm.get('ACTimeZone').updateValueAndValidity();
            this.alternateContactForm.get('ACKeypadZone').updateValueAndValidity();
            this.loaderIcon = Promise.resolve(false);
        } catch (error) {
            this.loaderIcon = Promise.resolve(false);
        }
    }

    GetFacilityGateSettings(facilityId, GateId) {
        this.facilityServices.GetFacilityGateDetailsForOp(facilityId, GateId).subscribe((response) => {
            if (response !== null) {
                this.gateSetting = response;
                this.gateAccessMaxLength = response.AccessCodeMaxLength;
                this.gateAccessMinLength = response.AccessCodeMinLength;
                this.alternateContactForm.get('ACGateCode').enable();
                this.alternateContactForm.get('ACGateCode').setValidators([Validators.required, this.noWhitespaceValidator, Validators.minLength(this.gateAccessMinLength), Validators.maxLength(this.gateAccessMaxLength)]);
                this.alternateContactForm.get('ACGateCode').updateValueAndValidity();
            }
            this.requireUniqueAccessCode = this.gateSetting.UniqueAccessCode;
        });
    }

    getIsGateCodeExist(gateCode: string, tenantId, alternateId) {
        this.prospectService.AccessCodeExist(gateCode, tenantId, this.FacilityId, this.LeaseNo, true, alternateId).subscribe((response: boolean) => {
            if (response === true) {
                this.isGateCodeExist = 1;
            } else if (this.isGateCodeExistsInList(gateCode) && this.gateSystemResponse.Id !== 4) {
                this.isGateCodeExist = 1;
            } else {
                this.isGateCodeExist = 0;
            }
        }, err => {
            this.isGateCodeExist = 0;
        });
    }

    onBlurGateCode(value) {
        this.isGateCodeExist = 2;
        if (value !== '') {
            this.getIsGateCodeExist(value, this.tenantId, 0);
        } else {
            this.isGateCodeExist = 0;
        }
    }

    validateZipInput(eve){
        this.commonMethodService.validateZipInput(eve);
      }

    onlyNumberKey(event) {
        return event.charCode == 8 || event.charCode == 0 ? "" : event.charCode >= 48 && event.charCode <= 57
    }

    onPaste(event: ClipboardEvent) {
        const pastedText = event.clipboardData?.getData('text') || '';
        if (!/^[0-9]*$/.test(pastedText)) {
            event.preventDefault();
            return;
        }
        this.codeChangeSubject.next(event);
    }

    getTimeZones(facilityId: number, gateId: number) {
        this.prospectService.GetFacilityTimeZone(facilityId, gateId).subscribe((response: ITimeZoneModel[]) => {
            this.timeZoneList = response.filter(tz => tz.InActive == false);
            this.timeZoneList.forEach((item) => {
                if (item.Default === true) { this.alternateContactForm.patchValue({ ACTimeZone: item.TimeZoneId }); }
            });
        });
    }

    getKeypadZones(facilityId: number, gateId: number) {
        this.prospectService.GetFacilityKeyPadZone(facilityId, gateId).subscribe((response: IKeypadZoneModel[]) => {
            this.keypadZoneList = response.filter(kpz => kpz.InActive == false);
            this.keypadZoneList.forEach((item) => {
                if (item.Default === true) { this.alternateContactForm.patchValue({ ACKeypadZone: item.KeypadZoneId }); }
            });
        });
    }

    checkGateSystemIntegrated(facilityId) {
        this.gateSystemResponse = this.FacilitygateSystemResponse;
        this.gateAccessChecked = this.FacilitygateSystemResponse.Success;
        if (this.gateAccessChecked) {
            this.GetFacilityGateSettings(facilityId, this.FacilitygateSystemResponse?.Id);
        }
        this.getTimeZones(facilityId, this.FacilitygateSystemResponse.Id);
        this.getKeypadZones(facilityId, this.FacilitygateSystemResponse.Id);
        this.alternateContactForm.markAsPristine();
        this.alternateContactForm.markAsUntouched();
    }

    async autoPopulateGateCode(facilityId): Promise<void> {
        const excludeCodes = [this.unitGateCode,
        ...this.alternateContactsGridData?.map(a => a.AccessCode) ?? []].filter(x => x != null && x !== '').map(x => String(x));
        const payload = {
            FacilityId: facilityId,
            TenantId: this.tenantId,
            LeaseNumber: this.LeaseNo,
            IsAlternateContact: true,
            AlternateContactId: 0,
            ExcludeIds: excludeCodes
        }
        const code = await this.prospectService.GenerateGateAccessCode(payload).toPromise();
        if (code) {
            this.autoGeneratedGateCode = String(code);
        } else {
            this.autoGeneratedGateCode = '';
        }
    }

    public noWhitespaceValidator(control: FormControl) {
        if ((control.value != '') && (control.value != null) && (control.value != undefined) && (typeof control.value === 'string' || control.value instanceof String)) {
            const isWhitespace = (control.value).trim().length === 0;
            const isValid = !isWhitespace;
            return isValid ? null : { 'whitespace': true };
        }
    }

    clearGateInfo(alternateId: number): boolean {
        const originalAltContact = this.existingAltContacts?.find(x => x.AlternateId === alternateId);

        const currentAltContact = this.alternateContactsGridData?.find(x => x.AlternateId === alternateId);
        if (!originalAltContact) {
            return false;
        }
        if (
            currentAltContact &&
            (
                originalAltContact.AccessCode !== currentAltContact.AccessCode ||
                originalAltContact.TimeZone !== currentAltContact.TimeZone ||
                originalAltContact.KeypadZone !== currentAltContact.KeypadZone
            )
        ) {
            return false;
        }
        return true;
    }

    invalidCarriedOverContacts(): boolean {
      return this.existingAltContacts?.some(originalAltContact => {
        const currentAltContact = this.alternateContactsGridData?.find(x => x.AlternateId === originalAltContact.AlternateId);
          if (!currentAltContact) {
                return true;
    }
            return (
              originalAltContact.AccessCode === currentAltContact.AccessCode &&
              originalAltContact.TimeZone === currentAltContact.TimeZone &&
              originalAltContact.KeypadZone === currentAltContact.KeypadZone
            );
        });
    } 

    gotoDetailsInReadonlyMode(item: any) {
        this.ContactList = item;
        this.generalService.getStates(item.CountryId).subscribe((response: IState[]) => {
            this.stateListAC = response;
        this.patchAlternateContactDetails(item);
        });
        this.modalWrapper.openDirective(this.alternateContactPopup);
        const keypadIdExistInList = this.keypadZoneList.findIndex(key => key.KeypadZoneId == item.KeypadZone);
        if (keypadIdExistInList === -1) {
            this.alternateContactForm.get('ACKeypadZone').patchValue('');
        }
        const timeZoneIdExistInList = this.timeZoneList.findIndex(key => key.TimeZoneId == item.TimeZone);
        if (timeZoneIdExistInList === -1) {
            this.alternateContactForm.get('ACTimeZone').patchValue('');
        }
    }

    gotoDetails(event, formDetails, index) {
        this.isEdit = true;
        this.itemIndex = index;
        this.formDetails = formDetails;
        let existingAlternateContacts = this.alternateContactsGridData.filter(alt => !alt.Deleted && alt.CheckAlternateContact);
        const isSameFacility = formDetails.FacilityId === this.FacilityId;
        if (formDetails.SendLetters) {
            this.alternateContactForm.get('ACAddress').setValidators([Validators.required, this.noWhitespaceValidator]);
            this.alternateContactForm.get('ACCity').setValidators([Validators.required, this.noWhitespaceValidator]);
            this.alternateContactForm.get('ACZipCode').setValidators([Validators.required, this.noWhitespaceValidator]);
            this.alternateContactForm.get('ACState').setValidators(Validators.required);
            this.alternateContactForm.get('IsPrimaryAlternateContact').enable();
        } else {
            this.alternateContactForm.get('ACAddress').setValidators(null);
            this.alternateContactForm.get('ACCity').setValidators(null);
            this.alternateContactForm.get('ACZipCode').setValidators(null);
            this.alternateContactForm.get('ACState').setValidators(null);
            this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
        }
        this.alternateContactForm.get('ACAddress').updateValueAndValidity();
        this.alternateContactForm.get('ACCity').updateValueAndValidity();
        this.alternateContactForm.get('ACZipCode').updateValueAndValidity();
        this.alternateContactForm.get('ACState').updateValueAndValidity();

        if (event.target.tagName !== 'SPAN' && event.target.tagName !== 'INPUT') {
            this.onACCountryChange(formDetails.CountryId);
            this.isGateCodeExist = 0;
            this.modalWrapper.openDirective(this.alternateContactPopup);
            this.emitAltContactForm.emit(true);
            setTimeout(() => {
                this.patchAlternateContactDetails(formDetails);
                if (existingAlternateContacts.length && this.isCreateRental && formDetails.GateAccess)          
                {
                  if (!isSameFacility && this.clearGateInfo(formDetails.AlternateId))
                  { 
                    this.alternateContactForm.patchValue({
                        ACGateCode: '',
                        ACTimeZone: '',
                        ACKeypadZone: ''
                    });
                    this.alternateContactForm.get('ACGateCode')?.setValidators([Validators.required]);
                    this.alternateContactForm.get('ACTimeZone')?.setValidators([Validators.required]);
                    this.alternateContactForm.get('ACKeypadZone')?.setValidators([Validators.required]);

                    this.alternateContactForm.get('ACGateCode')?.updateValueAndValidity();
                    this.alternateContactForm.get('ACTimeZone')?.updateValueAndValidity();
                    this.alternateContactForm.get('ACKeypadZone')?.updateValueAndValidity();

                    this.alternateContactForm.get('ACGateCode')?.markAsTouched();
                    this.alternateContactForm.get('ACTimeZone')?.markAsTouched();
                    this.alternateContactForm.get('ACKeypadZone')?.markAsTouched();
                    this.existingAltContactDirtyFlag.emit(this.alternateContactForm.invalid); // send it to rental
                  }
              }
            }, 600);
            if (!formDetails.CheckAlternateContact) {
                this.alternateContactForm.get('GateAccess').setValue(true);
                this.alternateContactForm.get('GateAccess').disable();
                this.gateAccessCheckedManually = true;
            } else {
                this.alternateContactForm.get('GateAccess').enable();
                this.gateAccessCheckedManually = false;
            }
        }

        if (!formDetails.GateAccess) {
            if(!this.gateAccessChecked){
                this.alternateContactForm.get('GateAccess').setValue(false);
                this.alternateContactForm.get('GateAccess').disable();
            }
            this.alternateContactForm.get('ACGateCode').disable();
            this.alternateContactForm.get('ACTimeZone').disable();
            this.alternateContactForm.get('ACKeypadZone').disable();
            this.alternateContactForm.patchValue({
                ACGateCode: '',
                ACTimeZone: '',
                ACKeypadZone: ''
            });
            this.alternateContactForm.get('ACGateCode').setValidators(null);
            this.alternateContactForm.get('ACTimeZone').setValidators(null);
            this.alternateContactForm.get('ACKeypadZone').setValidators(null);

            this.alternateContactForm.get('ACGateCode').updateValueAndValidity();
            this.alternateContactForm.get('ACTimeZone').updateValueAndValidity();
            this.alternateContactForm.get('ACKeypadZone').updateValueAndValidity();
        } else {
            this.gateAccessChecked = true;
            this.alternateContactForm.get('ACGateCode').enable();
            this.alternateContactForm.get('ACTimeZone').enable();
            this.alternateContactForm.get('ACKeypadZone').enable();
            const keypadIdExistInList = this.keypadZoneList.findIndex(key => key.KeypadZoneId == formDetails.KeypadZone);
            if (keypadIdExistInList === -1) {
                this.alternateContactForm.get('ACKeypadZone').patchValue('');
            }
            const timeZoneIdExistInList = this.timeZoneList.findIndex(key => key.TimeZoneId == formDetails.TimeZone);
            if (timeZoneIdExistInList === -1) {
                this.alternateContactForm.get('ACTimeZone').patchValue('');
            }
            this.alternateContactForm.get('ACGateCode').setValidators([Validators.required, this.noWhitespaceValidator, Validators.minLength(this.gateAccessMinLength)]);
            this.alternateContactForm.get('ACTimeZone').setValidators(Validators.required);
            this.alternateContactForm.get('ACKeypadZone').setValidators(Validators.required);

            this.alternateContactForm.get('ACGateCode').updateValueAndValidity();
            this.alternateContactForm.get('ACTimeZone').updateValueAndValidity();
            this.alternateContactForm.get('ACKeypadZone').updateValueAndValidity();
        }
        if (existingAlternateContacts.length == 1) {
            this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
        }
        setTimeout(() => {
            this.alternateContactForm.markAsPristine();
        }, 20);
    }

    get getAlternateContactService() {
        return this.facOpsDataService.alternateContactInfo;
    }
    set setAlternateContactService(value) {
        this.facOpsDataService.alternateContactInfo = value;
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    }

    cancelACForm(template: TemplateRef<any>) {
        if (this.alternateContactForm.dirty === true && this.alternateContactForm.touched === true) {
            this.openModal(template);
        } else {
            this.alternateContactPopup.hide();
            this.emitAltContactForm.emit(false);
        }
        this.alternateContactInfo.emit(this.alternateContactsGridData);
        //removing model pop-up class manully
        if ((document.querySelector('body') as HTMLElement).classList?.contains('modal-open')) {
            (document.querySelector('body') as HTMLElement).classList.remove('modal-open');
        }
    }

    onCancelAC() {
        this.alternateContactPopup.hide();
        this.emitAltContactForm.emit(false);
        this.sendLettersChecked = false;
        if (this.modalRef) {
            this.modalRef.hide();
        }
        this.alternateContactForm.get('ACAddress').setValidators(null);
        this.alternateContactForm.get('ACCity').setValidators(null);
        this.alternateContactForm.get('ACZipCode').setValidators(null);
        this.alternateContactForm.get('ACState').setValidators(null);
        this.alternateContactForm.get('ACAddress').updateValueAndValidity();
        this.alternateContactForm.get('ACCity').updateValueAndValidity();
        this.alternateContactForm.get('ACZipCode').updateValueAndValidity();
        this.alternateContactForm.get('ACState').updateValueAndValidity();
        this.autoGeneratedGateCode = '';
    }

    setMandatoryField() {
        this.generalService.GetMandatoryFields(this.FacilityId, 'alternate-contact.component.html', 'alternateContactForm')
            .subscribe((response: IGetPermissionMandatoryField) => {
                var data = response;
                if (data.Form.ListOfProperties.length != 0) {
                    this.alternateContactReqList = data.Form.ListOfProperties;
                    this.LocationFields = this.alternateContactReqList;
                    data.Form.ListOfProperties.forEach(field => {
                        const formControlName = field.Name === 'CheckPrimaryAlternate' ? 'IsPrimaryAlternateContact' : field.Name
                        if (formControlName != 'ACWorkPhoneExtn') {
                            if (field.Required) {
                                if (formControlName == 'ACEmail') {
                                    this.alternateContactForm.get(formControlName).setValidators([Validators.required, Validators.pattern(this.emailIdsPattern)]);
                                } else if (formControlName == 'ACCellPhone' || formControlName == 'ACHomePhone' || formControlName == 'ACWorkPhone' || formControlName == 'ACFax') {
                                    this.alternateContactForm.get(formControlName).setValidators([Validators.required, this.cellPhoneValidator]);
                                } else if (formControlName == 'Sendletters') {
                                    this.alternateContactForm.get('SendLetters').setValidators([Validators.required]);
                                } else {
                                    this.alternateContactForm.get(formControlName).setValidators([Validators.required, this.noWhitespaceValidator]);
                                }
                            } else {
                                if (formControlName == 'ACEmail') {
                                    this.alternateContactForm.get(formControlName).setValidators(Validators.pattern(this.emailIdsPattern))
                                } else if (formControlName == 'ACCellPhone' || formControlName == 'ACHomePhone' || formControlName == 'ACWorkPhone' || formControlName == 'ACFax') {
                                    this.alternateContactForm.get(formControlName).setValidators(this.cellPhoneValidator);
                                } else if (formControlName == 'Sendletters') {
                                    this.alternateContactForm.get('SendLetters').setValidators(null);
                                } else {
                                    this.alternateContactForm.get(formControlName).setValidators(null);
                                }
                            }
                            if (formControlName == 'Sendletters') {
                                this.alternateContactForm.get('SendLetters').updateValueAndValidity();
                            } else {
                                this.alternateContactForm.get(formControlName).updateValueAndValidity();
                            }
                        }

                    });
                }
            })
    }

    public cellPhoneValidator(control: FormControl) {
        if (control.value && (control.value !== '') && (control.value !== null)) {
            const isWhitespace = (control.value).trim().length < 10;
            const isValid = !isWhitespace;
            return isValid ? null : { 'lessThanTen': true };
        }
    }

    isRequired(control) {
        if (this.alternateContactForm.get(control).validator !== null) {
            const validator = this.alternateContactForm.get(control).validator({} as AbstractControl);
            return validator && validator.required ? true : false;
        } else {
            return false
        }
    }

  async  alternateOrAuthClick(value) {
        if (value) {
            if (this.IsSendLateLienNotices) {
                this.alternateContactForm.get('SendLetters').setValue(true)
                this.alternateContactForm.get('SendLetters').disable();
                this.alternateContactForm.get('IsEmergencyContact').setValue(true)
                this.alternateContactForm.get('IsEmergencyContact').disable();
                this.alternateContactForm.get('GateAccess').setValue(false)
                this.alternateContactForm.get('GateAccess').enable();
                await this.enableGateFields(false, 0, 0);
                this.alternateContactForm.get('ACAddress').setValidators([Validators.required, this.noWhitespaceValidator]);
                this.alternateContactForm.get('ACCity').setValidators([Validators.required, this.noWhitespaceValidator]);
                this.alternateContactForm.get('ACZipCode').setValidators([Validators.required, this.noWhitespaceValidator]);
                this.alternateContactForm.get('ACState').setValidators(Validators.required);
                this.alternateContactForm.get('ACAddress').updateValueAndValidity();
                this.alternateContactForm.get('ACCity').updateValueAndValidity();
                this.alternateContactForm.get('ACZipCode').updateValueAndValidity();
                this.alternateContactForm.get('ACState').updateValueAndValidity();
            } else if (!this.gateAccessChecked) {
                this.alternateContactForm.get('GateAccess').setValue(false);
                this.alternateContactForm.get('GateAccess').disable();
                await this.enableGateFields(false, 0, 0);
            } else {
                this.alternateContactForm.get('GateAccess').setValue(false);
                this.alternateContactForm.get('GateAccess').enable();
                await this.enableGateFields(false, 0, 0);
            }

            if (this.alternateContactsGridData == null) {
                this.alternateContactForm.get('IsPrimaryAlternateContact').setValue(true)
                this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
            } else {
                if (this.alternateContactsGridData.length > 1) {
                    this.alternateContactForm.get('IsPrimaryAlternateContact').enable();
                } else {
                    this.alternateContactForm.get('IsPrimaryAlternateContact').setValue(false)
                    this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
                }
            }
        } else {
            this.alternateContactForm.get('SendLetters').setValue(false)
            this.alternateContactForm.get('SendLetters').enable();
            this.alternateContactForm.get('IsEmergencyContact').setValue(false)
            this.alternateContactForm.get('IsEmergencyContact').enable();
            this.sendLettersChecked = false;
            this.checkValidityOfLocationFields();
            this.alternateContactForm.get('IsPrimaryAlternateContact').setValue(false)
            if (this.gateAccessChecked) {
                this.alternateContactForm.get('GateAccess').setValue(true)
                this.alternateContactForm.get('GateAccess').disable();
                await this.enableGateFields(true, 0, 0);
            } else {
                this.alternateContactForm.get('GateAccess').setValue(false);
                this.alternateContactForm.get('GateAccess').disable();
                await this.enableGateFields(false, 0, 0);
            }
        }
    }

    validatePrimaryContact(eve) {
        if (eve.target.checked) {
            let isPrimaryExists = this.alternateContactsGridData.some(alt => alt.IsPrimaryAlternateContact && !alt.Deleted)
            if (isPrimaryExists) {
                this.primaryValidationTemplateModalRef = this.modalService.show(this.primaryValidationTemplate, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
            }
        } else {
            this.makePrimaryContact(false)
        }
    }

    validateEmergencyContact(eve) {
        if (eve.target.checked) {
            let emergencyContactExists = this.alternateContactsGridData.some(alt => alt.IsPrimaryAlternateContact && !alt.Deleted)
            if (emergencyContactExists) {
                this.primaryValidationTemplateModalRef = this.modalService.show(this.primaryValidationTemplate, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
            }
        } else {
            this.makePrimaryContact(false)
        }
    }
    makePrimaryContact(isMake) {
        if (this.primaryValidationTemplateModalRef) {
            this.primaryValidationTemplateModalRef.hide();
        }
        if (isMake) {
            this.alternateContactsGridData.map(alt => {
                alt.IsPrimaryAlternateContact = false;
            });
            this.alternateContactForm.get('IsPrimaryAlternateContact').disable();
            this.alternateContactForm.markAsDirty();
        } else {
            let index = this.backUpAlternateContactData.findIndex(alt => alt.IsPrimaryAlternateContact == true);
            if (index !== -1) {
                this.alternateContactsGridData[0].IsPrimaryAlternateContact = true;
            }
        }
    }

    makePrimaryContactInGrid(i) {
        this.alternateContactsGridData.map(alt => alt.IsPrimaryAlternateContact = false);
        this.alternateContactsGridData[i].IsPrimaryAlternateContact = true;
        this.alternateContactInfo.emit(this.alternateContactsGridData);
        this.dirtyFlag.emit(true);
    }

    disableSave() {
        if ((!this.alternateContactForm.valid) || (this.isGateCodeExist == 2 || this.isGateCodeExist == 1 || !this.alternateContactForm.dirty)) {
            return true
        } else {
            return false
        }
    }

    closePrimaryvalidation() {
        this.alternateContactForm.get('IsPrimaryAlternateContact').patchValue(false);
        this.primaryValidationTemplateModalRef.hide()
    }

    isGateCodeExistsInList(gateCode) {
        let records = [];
        records = this.alternateContactsGridData.filter((item) => {
            if (item.AlternateId !== this.alternateContactForm.value.ACId && item.AccessCode == gateCode) {
                return item;
            }
        });
        if (records.length || (this.unitGateCode && this.unitGateCode !== '' && gateCode == this.unitGateCode)) {
            return true;
        } else {
            return false;
        }
    }

    restrictSpace(eve) {
        if (eve.which === 32) {
            eve.preventDefault();
        }
    }

    reopenOnNotCancel() {
        this.modalRef.hide();
        this.modalWrapper.openDirective(this.alternateContactPopup)
        this.emitAltContactForm.emit(true);
    }

    checkValidityOfLocationFields() {
        const locationfieldsArray = [ 'ACAddress', 'ACCity', 'ACZipCode', 'ACState' ];
        var LocationFieldstemp = this.LocationFields?.filter( item => locationfieldsArray.includes(item.Name));
        LocationFieldstemp = LocationFieldstemp?.forEach( item => {
            if (item.Required) {
                this.alternateContactForm.get(item.Name).setValidators([Validators.required, this.noWhitespaceValidator]);
                this.alternateContactForm.get(item.Name).updateValueAndValidity();
            } else if (!item.Required && this.sendLettersChecked) {
                this.alternateContactForm.get(item.Name).setValidators([Validators.required, this.noWhitespaceValidator]);
                this.alternateContactForm.get(item.Name).markAsTouched();
            }
            else if (!item.Required && this.emergencyContactChecked) {
                this.alternateContactForm.get(item.Name).setValidators([Validators.required, this.noWhitespaceValidator]);
                this.alternateContactForm.get(item.Name).markAsTouched();
            }
            else {
                this.alternateContactForm.get(item.Name).setValidators(null);
                this.alternateContactForm.get(item.Name).setErrors(null);
            }
        });
    }

    patchAlternateContactDetails(details: any) {
        this.alternateContactForm.patchValue({
            ACId: details.AlternateId,
            ACFirstName: details.FirstName,
            ACMiddleName: details.MiddleName,
            ACLastName: details.LastName,
            ACAddress: details.Address,
            ACCity: details.City,
            ACState: Number(details.CountryId) !== 1 && Number(details.CountryId) !== 2 ? 0 : Number(details.State?.Id ?? details.State) || null,
            ACZipCode: details.Zip,
            ACCountry: details.CountryId,
            ACCellPhone: details.CellPhoneNumber,
            ACCellDialInCode: details.CellPhoneCountryId,
            ACHomePhone: details.HomePhone,
            ACHomeDialInCode: details.HomePhoneCountryId,
            ACWorkPhone: details.WorkPhone,
            ACWorkDialInCode: details.WorkPhoneCountryId,
            ACEmail: details.Email,
            ACFax: details.Fax,
            ACFaxDialInCode: details.FaxCountryId,
            SendLetters: details.SendLetters,
            IsEmergencyContact: details.IsEmergencyContact,
            GateAccess: details.GateAccess,
            ACGateCode: details.AccessCode,
            ACTimeZone: details.TimeZone,
            ACKeypadZone: details.KeypadZone,
            CheckAlternateContact: details.CheckAlternateContact.toString(),
            IsPrimaryAlternateContact: details.IsPrimaryAlternateContact
        });
    }

  private validateCarriedOverContacts(): void {

    const hasInvalidContacts = this.alternateContactsGridData.some(contact =>
      contact.CheckAlternateContact &&
      contact.GateAccess &&
      contact.FacilityId !== this.FacilityId &&
      this.clearGateInfo(contact.AlternateId)
    );

    this.existingAltContactDirtyFlag.emit(hasInvalidContacts);
  }
}
